/** @jsxImportSource @emotion/react */
"use client";

import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { actionButton, cookieBannerContainer, linkButton } from "./styles";

const cookieKey = "cookieAccepted";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isAccepted = localStorage.getItem(cookieKey);
    if (!isAccepted) {
      queueMicrotask(() => {
        setVisible(true);
      });
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(cookieKey, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Grid container flexDirection="row" css={cookieBannerContainer}>
      <Grid size={{ xs: 12, sm: 10 }}>
        <Typography variant="body2">
          Sitemizden en iyi şekilde faydalanabilmeniz için çerezler
          kullanılmaktadır.
        </Typography>
        <Typography variant="body2">
          Çerezler hakkında detaylı bilgi almak ve çerez politikasını incelemek
          için{" "}
          <Link href="/cerez-politikasi" css={linkButton}>
            tıklayın.
          </Link>
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 2 }} display="flex" alignItems="center">
        <Button variant="contained" css={actionButton} onClick={handleAccept}>
          TAMAM
        </Button>
      </Grid>
    </Grid>
  );
};

export default CookieBanner;
